//Install
import React, { Component } from "react";
//Install
import { Container, Row, Col } from "react-bootstrap";
//Install
import Header from "../../Header";
//Install
import Footer from "../../Footer";
//Install
import T723BA from "../../../../../Media/Image/038.jpg";

//Element
class Default extends Component {
    //Element
    componentDidMount() {
        //Element
        document.title = "Karyera : Temas Elektrik Müqaviləsi"
        //Element
        document.getElementsByTagName("meta")["description"].content = "Temas Elektrik, Davamlı və Etibarlı Enerji Xidmətləri ilə Hər Toxunuş Gələcəyə Dəyər Qatar."
        //Element
        let URL = "https://temaselektrik.com/az/karyera"
        //Element
        let Canonical = document.querySelector("link[rel='canonical']")
        //Element
        Canonical.setAttribute("href", URL);
    }
    //Element
    render() {
        //Element
        const Content = React.createElement("div", { className: "website-application" },
            //Element
            React.createElement(Header, {}),
            //Element
            React.createElement("main", { className: "S6pt64 C96Q4r pEO064 a527eB d3c437" },
                //Element
                React.createElement("section", { className: "S6pt64 C96Q4r pEO064 a527eB f1d74t" },
                    //Element
                    React.createElement("div", { className: "S6pt64 C96Q4r pEO064 a527eB p33e0e" },
                        //Element
                        React.createElement("figure", { className: "S6pt64 C96Q4r pEO064 a527eB q84s6o" })
                    )
                ),
                //Element
                React.createElement("section", { className: "S6pt64 C96Q4r pEO064 a527eB gq620v" },
                    //Element
                    React.createElement(Container, {},
                        //Element
                        React.createElement(Row, {},
                            //Element
                            React.createElement(Col, { md: 12 },
                                //Element
                                React.createElement("div", { className: "S6pt64 C96Q4r pEO064 a527eB v431h7" },
                                    //Element
                                    React.createElement("div", { className: "S6pt64 C96Q4r pEO064 a527eB yk8549" },
                                        //Element
                                        React.createElement("h1", { className: "S6pt64 C96Q4r pEO064 a527eB u7760y" },
                                            //Element
                                            "Karyera"
                                        )
                                    )
                                )
                            ),
                            //Element
                            React.createElement(Col, { md: 6 },
                                //Element
                                React.createElement("div", { className: "S6pt64 C96Q4r pEO064 a527eB q95k0u" },
                                    //Element
                                    React.createElement("h2", { className: "S6pt64 C96Q4r pEO064 a527eB q887o2" },
                                        //Element
                                        "Ehtirasını İşə ",
                                        //Element
                                        React.createElement("strong", {},
                                            //Element
                                            "Çevir, "
                                        ),
                                        //Element
                                        "Sərhədləri Zorla"
                                    ),
                                    //Element
                                    React.createElement("p", { className: "S6pt64 C96Q4r pEO064 a527eB j39v3u" },
                                        //Element
                                        "Temas Elektrik Müqaviləsi Enerjini Yalnız Dəyişdirmir; Eyni Zamanda Bu Günün Və Gələcəyin Bacarıqlarını Da İnkişaf Etdirir. Dinamik İş Mühitimizdə Bacarıqlarını Təkmilləşdirə Və Sektor­da Fərq Yaradan Həllər Yarada Bilərsən."
                                    ),
                                    //Element
                                    React.createElement("p", { className: "S6pt64 C96Q4r pEO064 a527eB j39v3u" },
                                        //Element
                                        "Komandamızın Bir Hissəsi Kimi Yaradıcı Qabiliyyətini Azad İfadə Edə, Dayanıqlı Öyrənmə Və İnkişaf Fürsətlərinə Çata Və Birlikdə Daha Davamlı Bir Gələcəyə Töhfə Verə Bilərsən."
                                    ),
                                    //Element
                                    React.createElement("p", { className: "S6pt64 C96Q4r pEO064 a527eB j39v3u" },
                                        //Element
                                        "Bizim Üçün Hər İşçi, Enerji Və Modernləşdirmə Zəncirinin Vazgeçilməz Bir Hissəsidir. Temas Elektrikdə Karyera Yalnız Bir İş Deyil, Gələcəyə Edilən Bir İnvestisiyadır."
                                    ),
                                    //Element
                                    React.createElement("a", { className: "S6pt64 C96Q4r pEO064 a527eB n82j8n", href: "mailto:ibrahim@temaselektrik.com" },
                                        //Element
                                        "Derhal Müraciət Et"
                                    )
                                )
                            ),
                            //Element
                            React.createElement(Col, { md: 6 },
                                //Element
                                React.createElement("picture", { className: "S6pt64 C96Q4r pEO064 a527eB e649gp" },
                                    //Element
                                    React.createElement("img", { alt: "Karyera", title: "Karyera", src: T723BA, width: "636", height: "auto" })
                                )
                            )
                        )
                    )
                )
            ),
            //Element
            React.createElement(Footer, {})
        )
        //Element
        return (
            Content
        );
    }
}
//Element
export default Default;